import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '../../../../../.muji/store';
import { Button, Row, Col } from 'antd';
import { Root, Top, Center, Tag, Footer } from '../_style/Operate';
import HammerModal from './HammerModal';
import AnswerPriceModal from './AuctionModal';
import { toNumber } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    _state: rootState.auctionOperate,
});
class Operate extends Component {
    constructor() {
        super(...arguments);
        this.cancelModal = () => {
            dispatch.auctionOperate.HIDE_HAMMER_MODAL();
        };
        this.okModal = () => {
            dispatch.auctionOperate.HIDE_HAMMER_MODAL();
            dispatch.auctionOperate.ALREADY_ASKPRICE();
            dispatch.auctionOperate.SET_CLICKTEN('answer');
            dispatch.auctionOperate.TRUE_STOP_TEN();
            dispatch.auctionOperate.SET_COUNT_NUM(10);
            dispatch.auctionOperate.goToCount({ countNum: 10, type: 'duringAnswer' });
        };
        /**
         * @desc 点击立即结束
         */
        this.immediatelyEnd = () => {
            dispatch.auctionOperate.immediatelyEnd({});
        };
        /**
         * @desc 点击10秒倒计时
         */
        this.beginTen = () => {
            dispatch.auctionOperate.beginTen({});
        };
        /**
         * @desc 点击10秒倒计时的暂停
         */
        this.stopTen = () => {
            dispatch.auctionOperate.stopTen({});
        };
        /**
         * @desc 点击10秒倒计时的继续
         */
        this.goOnTen = () => {
            dispatch.auctionOperate.goOnTen({});
        };
        /**
         * @desc 点击10秒倒计时的暂停应价
         */
        this.stopAnswerTen = () => {
            dispatch.auctionOperate.stopTen({});
        };
        /**
         * @desc 点击10秒倒计时的继续应价
         */
        this.goOnAnswerTen = () => {
            dispatch.auctionOperate.goOnTen({});
        };
        /**
         * @desc 点击成交按钮
         */
        this.optDeal = () => {
            dispatch.auctionOperate.optDeal({});
        };
        /**
         * @desc 点击待成交按钮
         */
        this.optWaitDeal = () => {
            dispatch.auctionOperate.optWaitDeal({});
        };
        /**
         * @desc 点击流拍按钮
         */
        this.optAbortive = () => {
            dispatch.auctionOperate.optAbortive({});
        };
        /**
         * @desc 点击询价按钮
         */
        this.optAskPrice = () => {
            dispatch.auctionOperate.optAskPrice({});
        };
        /**
         * @desc 点击确认或取消 应价提示
         */
        this.closeAnswer = () => {
            dispatch.auctionOperate.HIDE_ANSWERPRICE_TIP();
        };
        /**
         * @desc 操作按钮的展示
         */
        this.getValues = () => {
            const { bidStatus, beginPrice, reservePrice, currentPrice, auctionMode, tenderHighestPriorityOfferW, basePriceRemind, nearBasePriceRemind } = this.props._state;
            let optStatus;
            /** 操作按钮自行判断保留价与(Max(当前价, 投标最高价))关系 */
            const temp1 = currentPrice ? currentPrice : beginPrice;
            const temp2 = Math.max(toNumber(temp1), toNumber(tenderHighestPriorityOfferW));
            /** 现场拍比较竞拍最高价 超级拍现场拍比较投标最高价和竞拍最高价 */
            const p = auctionMode === 1011 ? temp2 : temp1;
            if (!reservePrice) {
                optStatus = 'noReservePrice';
            }
            else {
                /** 如果有保留价，过保留价则展示成交按钮；未过保留价，判断是否开启红绿黄灯，开启则展示待成交，询价，流拍，未开启则展示成交，待成交，询价，流拍 */
                optStatus = toNumber(p) < toNumber(reservePrice) ? (basePriceRemind === 0 && nearBasePriceRemind === 0) ? 'underReservePriceWhole' : 'underReservePrice' : 'overReservePrice';
            }
            optStatus = bidStatus ? optStatus : 'none';
            return optStatus;
        };
        /**
         * @desc 展示保留价以及标签：当前最高价与保留价之间关系
         */
        this.renderBasePriceAndTags = () => {
            const { exceedBasePrice, reservePrice } = this.props._state;
            let tagText;
            switch (exceedBasePrice) {
                case 0: // 不展示保留价（未设置保留价）
                    if (!reservePrice) {
                        tagText = '未设置保留价';
                    }
                    break;
                case 1: // 等于大于保留价
                    tagText = '高于保留价';
                    break;
                case 2: // 低于保留价
                    tagText = '低于保留价';
                    break;
                case 3: // 接近保留价
                    tagText = '接近保留价';
                    break;
            }
            return (<div className="part--reservePrice flex__row-btE">
        {reservePrice &&
                <div className="part--price">
            保留价
            <span className="icon">¥</span>
            <span className="price"> {reservePrice} </span>
            <span className="unit">万元</span>
          </div>}
        
        {tagText && <Tag className="tag--priceCompare">{tagText}</Tag>}
      </div>);
        };
        /**
         * @desc 超级拍现场拍 && 展示投标最高价以及标签：当前最高价与投标价之间关系
         */
        this.renderTenderHighestPriceAndTags = () => {
            const { moreThanTender, tenderHighestPriorityOfferW, auctionMode, compareWithTenderDisplay } = this.props._state;
            // 如果不是超级拍现场拍 返回null;
            if (auctionMode !== 1011) {
                return null;
            }
            let tagText;
            // 如果开启投标价与当前价关系提醒则展示高于|低于投标价
            if (compareWithTenderDisplay === 1) {
                switch (moreThanTender) {
                    case 0: // 低于投标价
                        tagText = '低于投标价';
                        break;
                    case 1: // 高于投标价
                        tagText = '高于投标价';
                        break;
                }
            }
            return (<div className="part--tenderHighestPrice flex__row-btE">
        <div className="part--price">
          投标最高价
          <span className="icon">¥</span>
          <span className="price"> {tenderHighestPriorityOfferW} </span>
          <span className="unit">万元</span>
        </div>
        
        {tagText && <Tag className="tag--priceCompare">{tagText}</Tag>}
      </div>);
        };
        /**
         * @desc 获取操作按钮 成交|待成交|询价|流拍|倒计时
         */
        this.getBtns = (stopBtn, type) => {
            const addClass = stopBtn ? 'stopBtn' : '';
            const { alreadyDeal, alreadyWaitDeal, alreadyAskPrice, alreadyAbortive, countNum } = this.props._state;
            const addBtnClass = (alreadyDeal || alreadyWaitDeal || alreadyAskPrice || alreadyAbortive) ? 'stopBtn' : '';
            const _disabledBtn1 = stopBtn || !!addBtnClass;
            const _disabledBtn2 = stopBtn;
            let _className;
            let _click;
            let _text;
            let _block = true;
            let _disable;
            switch (type) {
                case 'deal':
                    _className = `btn--deal ${addClass} ${addBtnClass}`;
                    _click = this.optDeal;
                    _text = alreadyDeal ? '已成交' : '成交';
                    _disable = _disabledBtn1;
                    break;
                case 'waitDeal':
                    _className = `btn--waitDeal ${addClass} ${addBtnClass}`;
                    _click = this.optWaitDeal;
                    _text = alreadyWaitDeal ? '已待成交' : '待成交';
                    _disable = _disabledBtn1;
                    break;
                case 'askPrice':
                    _className = `btn--askPrice ${addClass} ${addBtnClass}`;
                    _click = this.optAskPrice;
                    _text = alreadyAskPrice ? '已询价' : '询价';
                    _disable = _disabledBtn1;
                    break;
                case 'abortive':
                    _className = `btn--abortive ${addClass} ${addBtnClass}`;
                    _click = this.optAbortive;
                    _text = alreadyAbortive ? '已流拍' : '流拍';
                    _disable = _disabledBtn1;
                    break;
                case 'immediateEnd':
                    _className = `btn_immediateEnd ${addClass}`;
                    _click = this.immediatelyEnd;
                    _text = '立即结束';
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
                case 'normalTen':
                    _className = `btn_tenSecond ${addClass}`;
                    _click = this.beginTen;
                    _text = `开启${countNum}s倒计时`;
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
                case 'stopTen':
                    _className = `btn_ten_stop ${addClass}`;
                    _click = this.stopTen;
                    _text = '暂停';
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
                case 'goOnTen':
                    _className = `btn_ten ${addClass}`;
                    _click = this.goOnTen;
                    _text = '继续';
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
                case 'stopAnswer':
                    _className = `btn_ten_stop ${addClass}`;
                    _click = this.stopAnswerTen;
                    _text = '暂停应价';
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
                case 'goOnAnswer':
                    _className = `btn_ten ${addClass}`;
                    _click = this.goOnAnswerTen;
                    _text = '继续应价';
                    _block = false;
                    _disable = _disabledBtn2;
                    break;
            }
            return (<Button disabled={_disable} block={_block} className={_className} onClick={_click}>
        {_text}
      </Button>);
        };
        /**
         * @desc 询价框里的当前价 nowPrice
         * @argument 现场拍的话为当前最高价 nowPrice = currentPriceY
         * @argument 超级拍现场拍的话为当前最高价与投标最高价的最大值 nowPrice = Max(currentPriceY, tenderHighestPriorityOfferY)
         */
        this.getNowPrice = () => {
            const { currentPriceY, tenderHighestPriorityOfferY, auctionMode } = this.props._state;
            if (auctionMode === 1011 && toNumber(tenderHighestPriorityOfferY) > toNumber(currentPriceY)) {
                return tenderHighestPriorityOfferY;
            }
            return currentPriceY;
        };
    }
    render() {
        const { netHight, sceneCount, scenePeopleNum, netCount, netPeopleNum, showHammerModal, canOperate, clickTen, stopTen, countNum, duration, answerPriceStatus, isTheLast, showAnswerPriceTip, stopBtn, nowCarAuctionId, sessionId, auctionStageHasBid, } = this.props._state;
        const optStatus = this.getValues();
        const DealButton = this.getBtns(stopBtn, 'deal');
        const WaitDealButton = this.getBtns(stopBtn, 'waitDeal');
        const AskPriceButton = this.getBtns(stopBtn, 'askPrice');
        const AbortiveButton = this.getBtns(stopBtn, 'abortive');
        const NormalTenButton = this.getBtns(stopBtn, 'normalTen');
        const immediateEndButton = this.getBtns(stopBtn, 'immediateEnd');
        const StopTenButton = this.getBtns(stopBtn, 'stopTen');
        const GoOnTenButton = this.getBtns(stopBtn, 'goOnTen');
        const StopAnswerButton = this.getBtns(stopBtn, 'stopAnswer');
        const GoOnAnswerButton = this.getBtns(stopBtn, 'goOnAnswer');
        const nowPrice = this.getNowPrice();
        return (<React.Fragment>
        <Root>
          <Top className="flex__row-bt">
              <div>
                  <div className="hasBid">本车已开拍</div>
                  <div className="duration">{duration}</div>
              </div>
              {clickTen === 'no' && countNum === 0 && immediateEndButton}
              {clickTen === 'no' && countNum !== 0 && NormalTenButton}
              {clickTen === 'begin' &&
            <div className="tenSecond flex__row-start">
                  <div className="ten">{countNum}s</div>
                  {stopTen && StopTenButton}
                  {!stopTen && GoOnTenButton}

                </div>}
              {clickTen === 'answer' &&
            <div className="tenSecond flex__row-start">
                  <div className="ten">{countNum}s</div>
                  {stopTen && StopAnswerButton}
                  {!stopTen && GoOnAnswerButton}

                </div>}
              {clickTen === 'end' &&
            <div className="btn_tenEnd">已结束</div>}
          </Top>
          <Center>
              <Row>
                  <Col span={8} offset={8}>出价次数</Col>
                  <Col span={8}>出价人数</Col>
              </Row>
              <Row>
                  <Col span={8} style={{ textAlign: 'left', position: 'relative' }}>
                      现场
                      {auctionStageHasBid && !netHight && <Tag className="tag--first">领先</Tag>}
                  </Col>
                  <Col span={8}>{sceneCount}</Col>
                  <Col span={8}>{scenePeopleNum}</Col>
              </Row>
              <Row>
                  <Col span={8} style={{ textAlign: 'left', position: 'relative' }}>
                      远程
                      {auctionStageHasBid && netHight && <Tag className="tag--first">领先</Tag>}
                  </Col>
                  <Col span={8}>{netCount}</Col>
                  <Col span={8}>{netPeopleNum}</Col>
              </Row>
          </Center>
          
          {this.renderBasePriceAndTags()}
          
          {this.renderTenderHighestPriceAndTags()}
          {canOperate &&
            <Footer className="flex__row-bt">
                  {optStatus === 'none' &&
                <React.Fragment>
                        {AbortiveButton}
                    </React.Fragment>}
                  {optStatus === 'noReservePrice' &&
                <React.Fragment>
                        {DealButton}
                        {WaitDealButton}
                        {AbortiveButton}
                    </React.Fragment>}
                  {optStatus === 'overReservePrice' &&
                DealButton}
                  {optStatus === 'underReservePrice' &&
                <React.Fragment>
                        {WaitDealButton}
                        {AskPriceButton}
                        {AbortiveButton}
                    </React.Fragment>}
                  {optStatus === 'underReservePriceWhole' &&
                <React.Fragment>
                        {DealButton}
                        {WaitDealButton}
                        {AskPriceButton}
                        {AbortiveButton}
                    </React.Fragment>}
              </Footer>}
        </Root>
        <HammerModal nowPrice={nowPrice} auctionId={nowCarAuctionId} roundId={sessionId} showCloseModal={showHammerModal} cancelClose={this.cancelModal} okClose={this.okModal}/>
        <AnswerPriceModal type={answerPriceStatus} isTheLast={isTheLast} id={nowCarAuctionId} countNum={countNum} showCloseModal={showAnswerPriceTip} okClose={this.closeAnswer} cancelClose={this.closeAnswer}/>
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(Operate);
